import React, { memo } from 'react';
import moment from 'moment';
import { Table } from 'appkit-react';

import D_Currency from '@utils/currency';

const formatCurrencyToString = ({ value, currencyIsoCode }) => {
  if (typeof value === 'undefined' || typeof currencyIsoCode === 'undefined') {
    return '-';
  }

  return D_Currency.format({ value, currencyIsoCode });
};

const AcquisitionHistoryTable = ({ acquisitionHistory }) => {
  const columns = [
    {
      Header: () => <span>company</span>,
      accessor: 'name',
      render: (row) => <div className="textInoneLine">{row.value}</div>,
    },
    {
      Header: 'date acquired',
      accessor: 'date',
      Cell: (row) => <div className="center">{row.value}</div>,
    },
    {
      Header: 'purchase price',
      accessor: 'value',
      Cell: (row) => (
        <div className="center">{formatCurrencyToString(row.value)}</div>
      ),
    },
  ];

  const dataSource = (acquisitionHistory || []).map(
    ({ name, date, value }) => ({
      name,
      date:
        date == null ? '-' : moment(date, 'YYYY-MM-DD').format('MMM DD, YYYY'),
      value: value == null ? {} : value,
    }),
  );

  const emptyTableClassName = 'empty-acquisition-history-table';
  const className =
    dataSource.length > 0 ? 'acquisition-history-table' : emptyTableClassName;

  return (
    <div className="bottom acquisition-history-table-wrapper">
      <Table
        className={className}
        data={[
          ...dataSource,
          {
            date: '1900-01-01',
            value: null,
            name: 'THIS ELEMENT IS AIMED TO SHOW ALL ROWS W/O PAGINATION',
          },
        ]}
        columns={columns}
        loading={false}
        size="lg"
        showPageSizeOptions={false}
        showPagination={false}
        sortable={false}
        resizable={false}
        striped={false}
        pageable={false}
        defaultPageSize={-1}
      />
    </div>
  );
};

export default memo(AcquisitionHistoryTable);
